import "./deliveryMainPage.scss";
import React from "react";
import { Link } from "react-router-dom";
import SiteHeader from "../../layout/SiteHeader";
import MenuList from "../MenuList/MenuList";
import { FOOD_ITEMS } from "../FoodData";
import { PHONE_MAIN_DISPLAY, PHONE_MAIN_TEL } from "../../../constants/contact";

const DeliveryMainPage = () => {
  const meals = FOOD_ITEMS;

  return (
    <div className="delivery-page">
      <SiteHeader tagline="Доставка" />

      <section className="delivery-page__hero">
        <div className="container delivery-page__hero-inner">
          <p className="section-label">Доставка из клуба</p>
          <h1 className="delivery-page__title">Закажите любимые блюда на дом</h1>
          <p className="delivery-page__subtitle">
            Бесплатная доставка от 3500 ₽. Оформление заказа — только по
            телефону: звоните, согласуйте время и состав корзины с администратором.
          </p>
          <div className="delivery-page__cta-row">
            <a className="cta-phone" href={PHONE_MAIN_TEL}>
              Позвонить для заказа · {PHONE_MAIN_DISPLAY}
            </a>
            <Link className="delivery-page__back" to="/">
              На главную
            </Link>
          </div>
        </div>
      </section>

      <section className="delivery-page__menu">
        <div className="container delivery-page__menu-inner">
          <MenuList
            categoryName="Ассорти из шашлыков"
            meals={meals.filter((meal) => meal.category === "sets")}
          />
          <MenuList
            categoryName="Блюда на мангале"
            meals={meals.filter((meal) => meal.category === "shashliks")}
          />
          <MenuList
            categoryName="Овощи на мангале"
            meals={meals.filter((meal) => meal.category === "vegetables")}
          />
          <MenuList
            categoryName="Салаты"
            meals={meals.filter((meal) => meal.category === "salads")}
          />
          <MenuList
            categoryName="Пицца"
            meals={meals.filter((meal) => meal.category === "pizzas")}
          />
          <MenuList
            categoryName="Напитки"
            meals={meals.filter((meal) => meal.category === "drinks")}
          />
          <MenuList
            categoryName="Соусы"
            meals={meals.filter((meal) => meal.category === "sauces")}
          />
        </div>
      </section>
    </div>
  );
};

export default DeliveryMainPage;
